import React, { useState } from 'react'
import { useSharedValue } from 'react-native-reanimated'
import Glass from '@ui/elements/Glass/Glass'
import Dots from '@ui/pagination/Dots'
import { ScrollView, View } from 'react-native'
import useIntroStore from 'hooks/useIntroStore'
import StaffLogin from './StaffLogin'
import PressableIcon from '@ui/buttons/PressableIcon'
import { router } from 'expo-router'

interface Props {
  standalone?: boolean
  onClose?: () => void
}

export const StaffLoginModal = ({ standalone, onClose }: Props) => {
  const [step, setStep] = useState(0)

  const toggleMode = useIntroStore((s) => s.toggleMode)

  const close = () => toggleMode('none')

  const showBack = step > 0 || !standalone

  const content = (
    <View className="items-center gap-4 overflow-hidden p-16 pt-16 ">
      {/* <View className="h-8 w-full items-center ">
        <Dots current={page} total={2} />
      </View> */}
      <StaffLogin />
      {showBack && (
        <View className="absolute left-8 top-8">
          <PressableIcon name="arrow-left" onPress={onClose ?? close} />
        </View>
      )}
    </View>
  )

  if (standalone) return content

  return (
    <Glass>
      <ScrollView
        overScrollMode="never"
        className="w-full"
        bounces={false}
        keyboardShouldPersistTaps="handled"
      >
        {content}
      </ScrollView>
    </Glass>
  )
}

export default StaffLoginModal
